import React, { useEffect } from 'react';
import { ContractInfo } from 'api/types/httpsTypes/contracts';
import { BuyAmount } from '../../Sections/BuyAmount';
import { TakeProfit } from '../../Sections/TakeProfit';
import { SafetyMeasures } from '../../Sections/SafetyMeasures';
import { useFormContext } from 'react-hook-form';
import { FormValues } from '../../schema';
import { DexTradeTemplate } from 'api/types/httpsTypes/dex-trade';
import { useActiveWallets } from 'modules/routing/activeWalletsProvider';

export function TradeForm({
  cta,
  sniped,
  contract,
  isEdit,
  allTemplates,
}: {
  cta: React.ReactNode;
  sniped: boolean;
  contract?: ContractInfo;
  isEdit?: boolean;
  allTemplates?: DexTradeTemplate[];
}) {
  const { activeWallets } = useActiveWallets();
  const { setValue, watch } = useFormContext<FormValues>();
  const chain = watch('chain');

  useEffect(() => {
    if (activeWallets && !isEdit) {
      setValue('wallets', activeWallets[chain]);
    }
  }, [activeWallets]);

  return (
    <div className="lg:grow lg:flex ">
      <div className="xxs:space-y-0 grow flex flex-col">
        <BuyAmount
          allTemplates={allTemplates}
          isEdit={isEdit}
          disabled={sniped}
          pool={contract?.liquidityInfo?.activePools[0]}
        />
        <TakeProfit />
        <div className="hidden lg:block xxs:py-2 border-tailwind xxs:border-x-0 xxs:border-t-0 xxs:border-dex-black-700">
          {cta}
        </div>
        <SafetyMeasures disabled={sniped} />
      </div>
      <div className="lg:hidden">{cta}</div>
    </div>
  );
}
